import React, { useState } from 'react';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    CircularProgress
} from '@mui/material';

import {
    deletePrintingProcess
} from '../../services/PrintingProcessService';

const PrintingProcessDelete = ({
    open,
    id,
    onClose,
    onSuccess
}) => {

    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {

        try {

            setLoading(true);

            await deletePrintingProcess(id);

            onSuccess();

        } catch (error) {

            console.error(
                'Delete Printing Process Error:',
                error
            );

        } finally {

            setLoading(false);
        }
    };

    return (

        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            maxWidth="xs"
            fullWidth
        >

            <DialogTitle>
                Delete Printing Process
            </DialogTitle>

            <DialogContent>

                <Typography>
                    Are you sure you want to delete
                    this Printing Process record?
                </Typography>

            </DialogContent>

            <DialogActions>

                <Button
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </Button>

                <Button
                    color="error"
                    variant="contained"
                    onClick={handleDelete}
                    disabled={loading}
                >

                    {loading ? (
                        <CircularProgress
                            size={22}
                            color="inherit"
                        />
                    ) : (
                        'Delete'
                    )}

                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default PrintingProcessDelete;